import { RelationshipTypeENUM } from '../../enums/ProductEnums';
import { AttributeSettingsDTO } from './AttributeSettingsDTO';
import { ConnectorDTO } from './ConnectorDTO';
import { ProductDTO } from './ProductDTO';
import { TransformationDataDTO } from './TransformationDataDTO';

export class ProductRelationShipDTO {
  id?: number;
  childProduct: ProductDTO | number; //If it is a attributeRelationship, this is product blueprint id.
  transformationData: TransformationDataDTO;
  relationshipType: RelationshipTypeENUM;
  addedByDefault: boolean;
  connectors: ConnectorDTO[] = [];
  ignoreCollision: boolean;
  parentAttributeOverride: AttributeSettingsDTO[];
  childAttributeOverride: AttributeSettingsDTO[];

  constructor(
    id: number | undefined,
    childProduct: ProductDTO | number,
    transformationData: TransformationDataDTO,
    relationShipType: RelationshipTypeENUM,
    addedByDefault: boolean,
    connectors: ConnectorDTO[] = [],
    ignoreColision: boolean,
    parentAttributeOverride: AttributeSettingsDTO[] = [],
    childAttributeOverride: AttributeSettingsDTO[] = [],
  ) {
    this.id = id;
    this.childProduct = childProduct;
    this.transformationData = transformationData;
    this.relationshipType = relationShipType;
    this.addedByDefault = addedByDefault;
    this.connectors = connectors;
    this.ignoreCollision = ignoreColision;
    this.parentAttributeOverride = parentAttributeOverride;
    this.childAttributeOverride = childAttributeOverride;
  }
}
